import type { Scheduling } from '@src/core/buyerApiClient';
import { findWholeDateScheduling } from '@src/domains/tariffs';
import type { TariffsPerType } from '@src/stores/product';

// Delegates to findWholeDateScheduling, which skips sold-out tariffs (selectedQuantity === 0)
// so a sold-out scheduling's cap cannot constrain unrelated available tariffs.
export function getWholeDateScheduling(listOfTariffsPerType: TariffsPerType[]): Scheduling | undefined {
  return findWholeDateScheduling(listOfTariffsPerType);
}

export function getTotalSelectedTariffQuantity(listOfTariffsPerType: TariffsPerType[]): number {
  return listOfTariffsPerType.reduce((sum, tariff) => sum + tariff.selectedQuantity, 0);
}

export function isTotalQuantityExceedingWholeDateLimit(listOfTariffsPerType: TariffsPerType[]): boolean {
  const wholeDate = getWholeDateScheduling(listOfTariffsPerType);
  if (!wholeDate) return false;

  const limit = wholeDate.occupationRates.quantity!.availableAmount!;
  return getTotalSelectedTariffQuantity(listOfTariffsPerType) > limit;
}
